import SaleGroup from "./SaleGroup";

/**
 * Sorts, groups, and renders all sale groups for the current filter selection.
 *
 * Grouping key: `{saleId}-{auctionDate}`
 * Sort order:   ascending by auctionDate
 */

const groupBySaleIdAndDate = (arr) =>
  arr.reduce((acc, p) => {
    const saleId = p.originalSaleId ?? p.saleId;
    if (saleId === null || saleId === undefined) return acc;
    const key = `${saleId}-${p.auctionDate}`;
    acc[key] = acc[key] || [];
    acc[key].push(p);
    return acc;
  }, {});

const PropertyList = ({
  properties,
  selectedState,
  selectedTimeFrame,
  favorites,
  registrations,
  onDetailsClick,
  onRegisterClick,
  onMapClick,
  onAddFavorite,
  onRemoveFavorite,
  isPropertyFavorite,
  isPropertyRegistered,
  triggerToast,
}) => {
  const grouped = groupBySaleIdAndDate(properties);

  const sortedGroups = Object.entries(grouped)
    .map(([key, props]) => ({
      saleIdDateKey: key,
      auctionDate: key.split("-").slice(1).join("-"),
      properties: props,
    }))
    .sort((a, b) => new Date(a.auctionDate) - new Date(b.auctionDate));

  return (
    <>
      {sortedGroups.map(({ saleIdDateKey, properties: groupProps }) => (
        <SaleGroup
          key={saleIdDateKey}
          saleIdDateKey={saleIdDateKey}
          properties={groupProps}
          selectedState={selectedState}
          selectedTimeFrame={selectedTimeFrame}
          favorites={favorites}
          registrations={registrations}
          onDetailsClick={onDetailsClick}
          onRegisterClick={onRegisterClick}
          onMapClick={onMapClick}
          onAddFavorite={onAddFavorite}
          onRemoveFavorite={onRemoveFavorite}
          isPropertyFavorite={isPropertyFavorite}
          isPropertyRegistered={isPropertyRegistered}
          triggerToast={triggerToast}
        />
      ))}
    </>
  );
};

export default PropertyList;
